import { getVoicemailService } from "@ntconnect/framework/pbx";

export const fetchVoicemailBox = (domain, extension, page, pageSize, search, filter) =>
  getVoicemailService().fetchVoicemailBox(domain, extension, page, pageSize, search, filter);

export const createVoicemailBox = (domain, params) =>
  getVoicemailService().createVoicemailBox(domain, params);

export const fetchVoicemails = (domain, extension, page, pageSize, search, filter) =>
  getVoicemailService().fetchVoicemails(domain, extension, page, pageSize, search, filter);

export const fetchVoicemailAudio = (domain, extension, messageId) =>
  getVoicemailService().fetchVoicemailAudio(domain, extension, messageId);

export const updateVoicemailBox = (domain, params, id) =>
  getVoicemailService().updateVoicemailBox(domain, params, id);

export const deleteVoicemailBox = (domain, id) =>
  getVoicemailService().deleteVoicemailBox(domain, id);

export const deleteVoicemailMessage = (domain, extension, messageId) =>
  getVoicemailService().deleteVoicemailMessage(domain, extension, messageId);

export const markVoicemailMessageAsRead = (domain, extension, messageId) =>
  getVoicemailService().markVoicemailMessageAsRead(domain, extension, messageId);
